import { useMediaQuery, useTheme, Breakpoint } from '@mui/material';

const useBreakpoint = (mode: "up" | "down" | "only" | "not", breakpoint: Breakpoint) => {
    const theme = useTheme();
    const result = useMediaQuery(theme.breakpoints[mode](breakpoint));

  return result;
}

export const useIsMobile = () => useBreakpoint("down", "sm");

export const useIsCompactLandscape = () =>
  useMediaQuery(
    "(orientation: landscape) and (max-height: 500px) and (max-width: 900px)"
  );

export default useBreakpoint;
